import "./app";
import "./lock-scroll";
import "./popup";
import anchorClick from "./anchor";
import "./counters";
import "./form";
import share from "./share";
import "./popup-cookie";
import "./animate";
import "./facts";
import "./projects";
import "./team";
import "./vacancies";
import "./orientation";
import "./photos";
import "./photos-new";
import "./vacancy";
import "./invitation";
import { randomInteger, throttle } from "./util";
import { debounce } from "lodash";

$("body").addClass("_ready");
// if ($('#promo')) {
//     $('#promo').imagesLoaded( { background: true }, function() {
//         $('body').addClass('_ready');
//     });
// } else {
//     $('body').addClass('_ready');
// }

// подключаем svg для ie 11
svg4everybody();

// animate.css эффекты
new WOW().init();

if (!$("html").is(".mobile") && !$("html").is(".tablet")) {
    $(".button").hover3d({
        selector: "> i",
        perspective: 100,
    });

    $(".vacancies__item").hover3d({
        selector: ".vacancies__card",
    });

    $(".articles-item").hover3d({
        selector: ".articles-card",
    });

    $(".projects-slider__nav").hover3d({
        selector: ".projects-slider__nav-wrap",
        perspective: 70,
    });

    if (
        window.navigator.userAgent.indexOf("MSIE ") > 0 ||
        window.navigator.userAgent.indexOf("Edge") > 0
    ) {
    } else {
        $(".vacancies__item")
            .on("mousemove", function (e) {
                var ax = -($(this).innerWidth() / 2 - e.offsetX) / 20;
                var ay = ($(this).innerHeight() / 2 - e.offsetY) / 10;
                $(this)
                    .find(".vacancies__card-img-pattern")
                    .attr(
                        "style",
                        "transform: translate(" +
                            ax / 10 +
                            "%," +
                            ay / 10 +
                            "%)"
                    );
                //$(this).find('.vacancies__card-img img:nth-child(2)').attr('style', 'transform: scale(1.1) translate('+ax/10+'%,'+ay/10+'%)');
                //$(this).find('.vacancies__card-img-bg').css('background-position', (50 - ax) + '% ' + (50 - ay) + '%');
            })
            .on("mouseout", function (e) {
                $(this).find(".vacancies__card-img-pattern").attr("style", "");
                //$(this).find('.vacancies__card-img img:nth-child(2)').attr('style', '');
                //$(this).find('.vacancies__card-img-bg').css('background-position', '50% 50%');
            });
    }

    $(".js-share").hover3d({
        selector: "> i",
        perspective: 10,
    });

    $(".js-vacancy-citation-image").hover3d({
        selector: "> img",
        perspective: 200,
        sensitivity: 100,
    });
}

//$('[style*='background-image:']').imagesLoaded( { background: true }, function() {
//    console.log('#container background image loaded');
//});

// шэрилки
$(".js-share").click(function (e) {
    e.preventDefault();
    share[$(this).data("share")]();
});

// обработка меню
let $toggler = $(".js-menu-toggler");
$toggler.on("click", function () {
    $("html").toggleClass("menu-opened", $(this).find("input").prop("checked"));
});

$(".menu__links").on("click", "a", function () {
    $(".js-menu-toggler input").prop("checked", false);
    $("html").toggleClass(
        "menu-opened",
        $(".js-menu-toggler input").prop("checked")
    );
});

// темизация меню в зависимости от блока под ним
function sectionVisible(elem) {
    let coords = elem.getBoundingClientRect();

    //let windowHeight = document.documentElement.clientHeight;
    // верхняя граница elem в пределах видимости ИЛИ нижняя граница видима
    //let topVisible = coords.top > 0 && coords.top < windowHeight;
    //let bottomVisible = coords.bottom < windowHeight && coords.bottom > 0;
    //return topVisible || bottomVisible;

    let val = coords.height + coords.top;
    return val >= 60 && val <= coords.height + 60;
}

function menuTheme() {
    //let sections = document.querySelectorAll('.js-section');
    let sections = document.querySelectorAll("[data-menu]");
    for (let i = sections.length - 1; i >= 0; i--) {
        if (sectionVisible(sections[i])) {
            //$('.js-header').toggleClass('_top', i == 0);
            $(".js-header").attr("data-theme", $(sections[i]).data("menu"));
            break;
        }
    }
    //$('.js-header').toggleClass('_fixed', $(window).scrollTop() >= 100);
    $(".js-header").toggleClass("_top", App.W.scrollTop() < 50);
}

let menuThemeThrottle = throttle(menuTheme, 80);

App.W.on("scroll", function () {
    menuThemeThrottle();
});

menuTheme();

$(".js-logo").click(function (e) {
    if (
        $(".js-header").is("._top") &&
        $(e.currentTarget).is("[data-redirect]")
    ) {
        e.preventDefault();
        window.location.href = $(e.currentTarget).data("redirect");
    } else {
        anchorClick(e);
    }
});

// отложенная загрузка картинок после загрузки картинок в html
$("body").imagesLoaded(
    {
        background: true,
    },
    function () {
        $("img[data-src]").each(function () {
            let $el = $(this);
            // для блока 'гордимся пректами' заменяем катринки для вертикально ориентированного планшета
            if (
                $el.is("[data-src-tablet]") &&
                device.tablet() &&
                device.portrait()
            ) {
                $el.attr("src", $el.data("src-tablet"));
            } else {
                $el.attr("src", $el.data("src"));
            }
        });
    }
);

// для блока 'гордимся пректами' заменяем катринки для вертикально ориентированного планшета
App.W.on("orientation:portrait", function () {
    $("img[data-src]").each(function (item) {
        let $el = $(item);
        $el.attr("src", $el.data("src-tablet"));
    });
});

App.W.on("orientation:landscape", function () {
    $("img[data-src]").each(function (item) {
        let $el = $(item);
        $el.attr("src", $el.data("src"));
    });
});

// загружаем рандомную картинку 404
$(".js-page-404-image").each(function () {
    const $img = $(this);
    const imgUrls = $img.data("src-random").split(",");
    const index = randomInteger(0, imgUrls.length - 1);

    this.src = imgUrls[index];

    window.onload = function () {
        $img.addClass("page-404-image-" + index);
    };
});

// клик по ссылке на стр. вакансии скролит к форме и раскрывает её
$(".js-anchor-to-form").click(function () {
    let href = $(this).attr("href");

    $("html, body").animate(
        {
            scrollTop: $(href).offset().top,
        },
        {
            duration: 370,
            easing: "linear",
        }
    );

    setTimeout(() => {
        $(".js-vacancy-invitation-form-open").trigger("click");
    }, 410);

    return false;
});

// подгрузка статей при скролле
let showArticles = false;
// флаг по которому отправляем повторно запрос только если в ответе не пусто
let switchRequest = true;

let page = Number($(".js-articles-items").attr("data-page"));

function scrollMore() {
    let $target = $(".js-articles-items");
    let url = $target.attr("data-url");

    if (showArticles) {
        return false;
    }

    let wt = App.W.scrollTop();
    let eh = $target.outerHeight() - 450;

    if (wt >= eh) {
        showArticles = true;
        if (switchRequest) {
            $.ajax({
                url: url,
                method: "get",
                dataType: "html",
                data: {
                    page: page,
                },
                success: function (data) {
                    let dataObj = JSON.parse(data);
                    if (dataObj.content) {
                        $target.append(dataObj.content);
                        $(".articles-item").hover3d({
                            selector: ".articles-card",
                        });
                    } else {
                        switchRequest = false;
                    }
                    showArticles = false;
                },
            });

            page = page + 1;
        }
    }
}

let scrollMoreThrottle = throttle(scrollMore, 200);

App.W.on("scroll", function () {
    scrollMoreThrottle();
});

let xMousePos = 0;
let yMousePos = 0;
let lastScrolledLeft = 0;
let lastScrolledTop = 0;

let $photosSlider = $(".js-photos-slider-life");
let $photosSlider2 = $(".js-slider-case");
let photosSliderOffset = $(".js-photos-slider-life").offset();
let photosSliderOffset2 = $(".js-slider-case").offset();


if ($photosSlider.length && $photosSlider2.length) {
    // функции для того чтобы кастомный курсор возворащался в обычный вид при скролле
    $(document).mousemove(function (event) {
        captureMousePosition(event);
    });

    $(window).scroll(function () {
        scrollThrottle();
    });
}

function captureMousePosition(event) {
    xMousePos = event.pageX;
    yMousePos = event.pageY;
    window.status = "x = " + xMousePos + " y = " + yMousePos;
}

function scroll() {
    if (lastScrolledLeft != $(document).scrollLeft()) {
        xMousePos -= lastScrolledLeft;
        lastScrolledLeft = $(document).scrollLeft();
        xMousePos += lastScrolledLeft;
    }
    if (lastScrolledTop != $(document).scrollTop()) {
        yMousePos -= lastScrolledTop;
        lastScrolledTop = $(document).scrollTop();
        yMousePos += lastScrolledTop;
    }
    window.status = "x = " + xMousePos + " y = " + yMousePos;

    if (
        yMousePos < photosSliderOffset.top ||
        yMousePos > photosSliderOffset.top + $photosSlider.outerHeight()
    ) {
        $photosSlider.removeClass("cursor");
    } else {
        $photosSlider.addClass("cursor");
    }

    if (
        yMousePos < photosSliderOffset2.top ||
        yMousePos > photosSliderOffset2.top + $photosSlider2.outerHeight()
    ) {
        $photosSlider2.removeClass("cursor");
    } else {
        $photosSlider2.addClass("cursor");
    }
}

let scrollThrottle = throttle(scroll, 100);

$(".read-more").click(function () {
    let $el = $(this);
    if ($el.hasClass("_in-popup")) {
        $el.closest(".js-common-popup")
            .find(".js-common-popup-close")
            .trigger("click");
    }
});

$(".rewards-group").mouseenter(function () {
    let nameReward = $(this).attr("data-name-reward");
    $(".rewards-imgs-items")
        .find(`[data-name-reward=${nameReward}]`)
        .addClass("_active");
});

$(".rewards-group").mouseleave(function () {
    let nameReward = $(this).attr("data-name-reward");
    $(".rewards-imgs-items")
        .find(`[data-name-reward=${nameReward}]`)
        .removeClass("_active");
});

const debounceScrollRewards = debounce(() => {
    if ($(".rewards-group-wrap").length && $(window).width() > 1280) {
        let element = $(".rewards-group-wrap");
        let height_el = element.offset().top;
        let outerHeight = element.outerHeight();

        if ($(window).scrollTop() > height_el) {
            $(".rewards-imgs-items").addClass("_fixed");
        } else if ($(window).scrollTop() < height_el + outerHeight) {
            $(".rewards-imgs-items").removeClass("_fixed");
        }
    }
}, 100);

App.W.on("scroll", () => {
    debounceScrollRewards();
});

Fancybox.bind('[data-fancybox]', {});